module.exports = __webpack_public_path__ + "img/2.9230fe22.png";